import { defineStore } from 'pinia'

export const useSidebarStore = defineStore('sidebar', {
  state: () => ({
    rotatingOverview: {
      active: false,
      user: {},
      wishesUpdated: false,
      absencesUpdated: false,
      schedulesUpdated: false,
    },
    administrativeOverview: { active: false, user: {} },
    overview: { active: false, facility: {}, parentFacility: {}, planningGroupView: false },
    settings: {
      active: false,
      facility: {},
      image: null,
      disabled: false,
    },
    vacationSettings: {
      active: false,
      facility: {},
      disabled: false,
    },
    parttime: {
      active: false,
      facility: {},
      image: null,
    },
    external: { active: false, rotation: null, facility: {} },
    edit: { active: false, facility: {}, parentFacility: {}, image: null },
    competence: { active: false, facility: {}, image: null },
    unit: { active: false, unit: {}, facility: {}, planningGroupView: false },
    unitEdit: { active: false, unit: {}, facility: {}, planningGroupView: false },
    planningGroupEdit: { active: false, planningGroup: null, mainFacilityId: null },
    twoFactorAuth: { active: false },
    labelEdit: { active: false, facilityId: null },
    shiftTagEdit: { active: false, mainFacilityId: null },
    dutyEdit: { active: false, facilityId: null },
    wishesActivityOverview: { active: false, user: {} },
    shiftEdit: { active: false, shift: null, config: null, versioning: false, configOnly: false },
  }),
  actions: {
    open(sidebar) {
      switch (sidebar.type) {
        case 'rotatingOverview':
          this.rotatingOverview.active = true
          this.rotatingOverview.user = sidebar.user
          this.rotatingOverview.wishesUpdated = false
          this.rotatingOverview.absencesUpdated = false
          this.rotatingOverview.schedulesUpdated = false
          break
        case 'administrativeOverview':
          this.administrativeOverview.active = true
          this.administrativeOverview.user = sidebar.user
          break
        case 'overview':
          this.overview.active = true
          this.overview.facility = sidebar.facility
          this.overview.parentFacility = sidebar.parentFacility
          this.overview.planningGroupView = sidebar.planningGroupView
          break
        case 'settings':
          this.settings.active = true
          this.settings.facility = sidebar.facility
          this.settings.image = sidebar.image
          break
        case 'vacationSettings':
          this.vacationSettings.active = true
          this.vacationSettings.facility = sidebar.facility
          break
        case 'parttime':
          this.parttime.active = true
          this.parttime.facility = sidebar.facility
          this.parttime.image = sidebar.image
          break
        case 'external':
          this.external.active = true
          this.external.facility = sidebar.facility
          this.external.rotation = sidebar.rotation
          break
        case 'edit':
          this.edit.active = true
          this.edit.facility = sidebar.facility
          this.edit.parentFacility = sidebar.parentFacility
          this.edit.image = sidebar.image
          break
        case 'competence':
          this.competence.active = true
          this.competence.facility = sidebar.facility
          this.competence.image = sidebar.image
          break
        case 'unit':
          this.unit.active = true
          this.unit.facility = sidebar.facility
          this.unit.unit = sidebar.unit
          this.unit.planningGroupView = sidebar.planningGroupView
          break
        case 'unitEdit':
          this.unitEdit.active = true
          this.unitEdit.facility = sidebar.facility
          this.unitEdit.unit = sidebar.unit
          this.unitEdit.planningGroupView = sidebar.planningGroupView
          break
        case 'planningGroupEdit':
          this.planningGroupEdit.active = true
          this.planningGroupEdit.planningGroup = sidebar.planningGroup ?? null
          this.planningGroupEdit.mainFacilityId = sidebar.mainFacilityId ?? null
          break
        case 'twoFactorAuth':
          this.twoFactorAuth.active = true
          break
        case 'labelEdit':
          this.labelEdit.active = true
          this.labelEdit.facilityId = sidebar.facilityId
          break
        case 'shiftTagEdit':
          this.shiftTagEdit.active = true
          this.shiftTagEdit.mainFacilityId = sidebar.mainFacilityId ?? null
          break
        case 'dutyEdit':
          this.dutyEdit.active = true
          this.dutyEdit.facilityId = sidebar.facilityId
          break
        case 'wishesActivityOverview':
          this.wishesActivityOverview.active = true
          this.wishesActivityOverview.user = sidebar.user
          break
        case 'shiftEdit':
          this.shiftEdit.active = true
          this.shiftEdit.shift = sidebar.shift ?? null
          this.shiftEdit.config = sidebar.config ?? null
          this.shiftEdit.versioning = sidebar.versioning ?? false
          this.shiftEdit.configOnly = sidebar.configOnly ?? false
          break
      }
      if (this[sidebar.type]) {
        this[sidebar.type].disabled = !!sidebar.disabled
      }
    },
    close(type) {
      switch (type) {
        case 'rotatingOverview':
          this.rotatingOverview.active = false
          break
        case 'administrativeOverview':
          this.administrativeOverview.active = false
          this.administrativeOverview.user = {}
          break
        case 'overview':
          this.overview.active = false
          this.overview.facility = {}
          this.overview.parentFacility = {}
          this.overview.planningGroupView = false
          break
        case 'settings':
          this.settings.active = false
          this.settings.facility = {}
          this.settings.image = null
          break
        case 'vacationSettings':
          this.vacationSettings.active = false
          this.vacationSettings.facility = {}
          break
        case 'parttime':
          this.parttime.active = false
          this.parttime.facility = {}
          this.parttime.image = null
          break
        case 'external':
          this.external.active = false
          this.external.facility = {}
          this.external.rotation = {}
          break
        case 'edit':
          this.edit.active = false
          this.edit.facility = {}
          this.edit.parentFacility = {}
          this.edit.image = null
          break
        case 'competence':
          this.competence.active = false
          this.competence.facility = {}
          this.competence.image = null
          break
        case 'unit':
          this.unit.active = false
          this.unit.facility = {}
          this.unit.unit = {}
          this.unit.planningGroupView = false
          break
        case 'unitEdit':
          this.unitEdit.active = false
          this.unitEdit.facility = {}
          this.unitEdit.unit = {}
          this.unitEdit.planningGroupView = false
          break
        case 'planningGroupEdit':
          this.planningGroupEdit.active = false
          this.planningGroupEdit.planningGroup = null
          this.planningGroupEdit.mainFacilityId = null
          break
        case 'twoFactorAuth':
          this.twoFactorAuth.active = false
          break
        case 'labelEdit':
          this.labelEdit.active = false
          this.labelEdit.facilityId = null
          break
        case 'shiftTagEdit':
          this.shiftTagEdit.active = false
          this.shiftTagEdit.mainFacilityId = null
          break
        case 'dutyEdit':
          this.dutyEdit.active = false
          this.dutyEdit.facilityId = null
          break
        case 'wishesActivityOverview':
          this.wishesActivityOverview.active = false
          this.wishesActivityOverview.user = {}
          break
        case 'shiftEdit':
          this.shiftEdit.active = false
          this.shiftEdit.shift = null
          this.shiftEdit.config = null
          this.shiftEdit.versioning = false
          this.shiftEdit.configOnly = false
          break
      }
      if (this[type]?.disabled) {
        this[type].disabled = false
      }
    },
    setWishesUpdateStatus(status) {
      this.rotatingOverview.wishesUpdated = status
    },
    setAbsencesUpdateStatus(status) {
      this.rotatingOverview.absencesUpdated = status
    },
    setSchedulesUpdateStatus(status) {
      this.rotatingOverview.schedulesUpdated = status
    },
  },
})
